import { List } from 'antd';

const ListItem = props => <List.Item {...props} />;

export default ListItem;
